var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isDismissed ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('div', {
    staticClass: "alert-banner",
    class: _vm.bannerClass
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('i', {
    class: _vm.iconClass
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _c('div', {
    staticClass: "action-area"
  }, [_vm.status === 'pending' ? _c('div', {
    staticClass: "pending-info"
  }, [_c('button', {
    staticClass: "alert-button alert-button-subtle",
    on: {
      "click": _vm.dismissAlert
    }
  }, [_vm._v(" Dismiss ")])]) : _vm.status === 'rejected' || _vm.status === 'not_submitted' ? _c('button', {
    staticClass: "alert-button",
    class: {
      'alert-button-warning': _vm.status === 'rejected'
    },
    on: {
      "click": _vm.navigateToRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _vm._e()])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }